import { merge } from 'lodash'
import themeSettings from '~/themes/oknanebodvere/settings'

const overloadSettings = {
  catalog: {
    defaultSortType: 'MostSoldSort',
  },
  checkout: {
    cardStyle: false,
    enablePromoCode: false,
  },
  global: {
    billingInputsAlwaysRequired: true,
  },
  selectBoxIcon: 'down-chevron',
  components: {
    AddToCartModalItemAdded: {
      alertAlwaysOnTop: true,
      modalWindowMaxWidth: 'md',
      buttonContinueShoppingIconSize: 'md',
      buttonCheckoutIcon: null,
    },
    ArticleBox: {
      articleInfo: {
        enable: true,
      },
      image: {
        width: 800,
        height: 450,
        crop: true,
      },
      linkReadMore: {
        button: 'primary btn-block', // link, primary or secondary
        enable: true,
      },
    },
    Carousel: {
      leftIcon: 'right',
      rightIcon: 'right',
      showPartOfNextProduct: false,
    },
    CatalogSorting: {
      options: ['MostSoldSort', 'PriceSortASC', 'PriceSortDESC'],
    },
    CatalogSubCategories: {
      countPerLine: {
        sm: 1,
        md: 3,
        lg: 3,
        xl: 3,
      },
      enable: true,
      image: {
        width: 125,
        height: 125,
      },
    },
    CartInfoDropDownContent: {
      buttonCheckoutIcon: null,
      showDeliveryDate: false,
    },
    CheckoutItemLine: {
      showItemRemoveButton: true,
      showDeliveryDate: false,
    },
    CheckoutMethodsShipper: {
      showDescriptionTooltip: false,
      showDeliveryDate: false,
    },
    CheckoutRecapBox: {
      showDeliveryDate: false,
    },
    ContactBox: {
      button: {
        style: 'cta',
      },
      sticky: {
        alwaysVisible: true,
        enable: false,
        stickyAt: null,
      },
    },
    CookieConsent: {
      enable: false,
    },
    EmployeeList: {
      showHeading: true,
      perLine: 2,
    },
    FeaturedArticles: {
      image: {
        position: 'left', // top, left
      },
      linkAllArticles: {
        enable: true,
      },
      perLine: {
        lg: 2,
      },
    },
    FrequentQuestionBox: {
      enableAccordion: true,
    },
    HeaderMain: {
      showContentColumn: false,
    },
    HeaderTop: {
      showRegistrationLink: false,
    },
    LanguageSwitcher: {
      enable: false, // Set `$languageSwitcherEnable` in `_variables.scss`
      type: 'flag',
      enableDownArrow: true,
    },
    LayoutCheckout: {
      // Make sure Sticky component is enabled in settings.
      headerStickyAt: 'vh/2', // 'vh', 'vh/x' where x is number (viewpoint height), number or null
      headerStickyEnable: false,
      showHeaderTop: true,
      showJavascriptRequired: true,
      showMainMenu: true,
      showNewsletter: true,
    },
    MainMenuMobile: {
      showSubLevelArrow: false,
      breakpoint: 'lg',
    },
    NewsletterForm: {
      button: 'secondary',
    },
    PageArticleDetail: {
      latestArticles: {
        count: 2,
        perLine: null,
      },
    },
    PageArticleList: {
      sidebar: {
        enable: true,
        position: 'left',
      },
    },
    PageArticleListCategory: {
      sidebar: {
        enable: true,
        position: 'left',
      },
    },
    PageCheckoutInfo: {
      buttonProceedCheckoutIcon: false,
      buttonBackIcon: 'arrow-back',
      buttonBackIconSize: 'md',
      layout: 'LayoutCheckout',
      showAresLoading: true,
      input: {
        formalTitle: {
          enable: false,
        },
        shipToShippingAddress: {
          enable: true,
        },
      },
      showTotalPriceWithoutTax: true,
    },
    PageCheckoutItems: {
      buttonCheckoutIcon: false,
      buttonContinueShoppingIcon: 'arrow-back',
      buttonContinueShoppingIconSize: 'md',
      layout: 'LayoutCheckout',
      topCategories: {
        enable: false,
      },
      showEmployees: true,
      showProductsVisited: false,
      showUniqueSellingPoints: true,
      showCheckoutNextSteps: true,
      enablePromoCodeItemLine: false,
    },
    PageCheckoutMethods: {
      buttonProceedCheckoutIcon: false,
      buttonBackIcon: 'arrow-back',
      buttonBackIconSize: 'md',
      layout: 'LayoutCheckout',
    },
    PageCheckoutFinished: {
      showRecapBox: false,
      customerInfoBox: false,
      showEmployees: true,
      showCartPackageInformation: false,
    },
    PageCatalog: {
      showFiltersBox: false,
      showUniqueSellingPoints: false,
      showProductsCounter: false,
      Pagination: {
        top: {
          showOnMobile: false,
          showOnDesktop: false,
        },
        iconPrevious: true,
        iconNext: true,
      },
    },
    PageHomepage: {
      featuredArticles: {
        count: 2,
      },
      showHomepageBranches: false,
    },
    PageHomepageMainHeading: {
      enable: false,
    },
    PageLogin: {
      registrationInfoButtonType: 'primary btn-sm-block',
    },
    PageNotFound: {
      topCategories: {
        enable: false,
      },
    },
    PageProductDetail: {
      enableConfigurator: true,
      parametersTable: {
        enable: true,
        manufacturer: {
          code: true,
        },
        showCatalogCode: true,
      },
      showAvailability: false,
      showAvailabilityInWarehouses: false,
      showDeliveryOptions: false,
      showProductReviewsSummary: false,
      showShortDescription: false,
      showRelatedCategories: false,
      showNotice: true,
    },
    PageRegister: {
      showAresLoading: true,
    },
    ProductBox: {
      badge: {
        color: 'red', // see tags color palette + primary color
      },
      contentOrder: {
        image: 0,
        name: 1,
        availability: 2,
        price: 3,
      },
      showDescription: false,
      showDeliveryDate: false,
    },
    ProductConfigurator: {
      addToCart: {
        multiplyPricesByQuantity: true,
        enableSticky: true,
      },
      sizes: {
        enable: true,
      },
    },
    ProductDetailImages: {
      badge: {
        color: 'green', // see tags color palette + primary color
      },
    },
    ProductsVisited: {
      align: 'left',
      component: 'ProductBox',
      enable: true,
      showClearOption: false,
    },
    RemoveButton: {
      icon: 'cross',
    },
    SearchInput: {
      enableDropdown: true,
      clearInputAfterSubmit: false,
      label: {
        icon: false,
      },
      button: {
        icon: true,
        show: true,
      },
    },
    Slider: {
      image: {
        height: 318, // Change SASSs variable $Slider-image-height
      },
      showTimerIndicator: false,
    },
    StarRating: {
      activeColor: '#FFC700',
    },
    VerticalMenu: {
      enableHeader: true,
    },
    VerticalMenuItem: {
      iconClose: 'arrow-right',
      iconOpen: 'arrow-down-box',
    },
    UniqueSellingPoints: {
      parentClass: 'row UniqueSellingPoints',
    },
  },
}

export default merge(themeSettings, overloadSettings)
